let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("39iSL")).then(() => parcelRequire('5H9GZ'));